import styled from "styled-components";
import { COLORS, FONT_SIZE } from "../../../constants/Styles";

export const CATEGORY_SIDEBAR_WIDTH = "250px";

export const CategorySidebarContainer = styled.div`
  width: ${CATEGORY_SIDEBAR_WIDTH};
`;

export const FilterIconContainer = styled.div`
  display: flex;
  margin-bottom: 1rem;
`;

export const FilterName = styled.div`
  font-size: ${FONT_SIZE.size16};
  color: ${COLORS.secondary};
  margin-left: 0.25rem;
  padding-top: 0.125rem;
`;

export const NestingContainer = styled.div<{ nestingIndex: number }>`
  padding-left: calc(1rem * ${({ nestingIndex }) => nestingIndex});
`;

export const CategoryContainer = styled.div`
  display: flex;
  margin-bottom: 1rem;
`;

export const SelectableCategory = styled.div<{ selected: boolean }>`
  font-size: ${FONT_SIZE.size16};
  color: ${({ selected }) =>
    selected ? COLORS.secondary : COLORS.secondaryLight};
  border-left: ${({ selected }) =>
    selected ? `2px solid ${COLORS.primary}` : "default"};
  padding-left: ${({ selected }) => (selected ? "0.5rem" : "0")};
  cursor: pointer;

  &:hover {
    color: ${COLORS.secondary};
  }
`;

export const ExpandIcon = styled.div`
  margin-left: 0.5rem;
  cursor: pointer;
`;
